'use client';

import { useQuery } from '@tanstack/react-query';

import { UnauthQueryOptions } from '@/api';

import { WelloOnlySectionClient } from './WelloOnlySectionClient';

const TEN_SECONDS = 10 * 1000;

export const WelloOnlySection = () => {
  const { data } = useQuery({
    ...UnauthQueryOptions[
      'get:/wello/v2/allows/home/event/december/benefit-amount'
    ](),
    refetchInterval: TEN_SECONDS,
  });

  const {
    currentTimeEvent1ParticipantLimit: participantLimit = 0,
    currentTimeEvent1RewardCount: rewardCount = 0,
  } = data?.context || {};

  return (
    <WelloOnlySectionClient
      participantLimit={participantLimit}
      rewardCount={rewardCount}
    />
  );
};
